import { graphqlClient } from 'src/graphql/client'
import { GetPlanMoveDocument } from 'src/graphql/generated/graphql'

export const getPlanMove = async (planIdFrom: number, planIdTo: number) => {
  return await graphqlClient.request(GetPlanMoveDocument, {
    planIdFrom,
    planIdTo,
  })
}
